export const centreMap = {
  KLT: "Kowloon Tong",
  CP: "Cyberport",
  RB: "Repulse Bay",
  RB2: "The Pulse 2",
  TP: "The Peak",
  TRB: "The Repulse Bay",
  BH: "Braemar Hill (North Point)",
  ZH: "Zhuhai",
  Home: "Home Tutoring",
  "Online-Onsite": "Online-onsite",
  "Online-Offsite": "Online-offsite",
};

export const centreOptions = Object.entries(centreMap).map(
  ([shortName, longName]) => ({ value: shortName, label: longName }),
);

export const centres = Object.keys(centreMap);

export const paymentOptions = [
  { label: "Cash", value: "Cash" },
  { label: "Bank Transfer", value: "Bank Transfer" },
  { label: "FPS", value: "FPS" },
  { label: "Cheque", value: "Cheque" },
  { label: "Octopus", value: "Octopus" },
  { label: "Payme", value: "Payme" },
  { label: "AE", value: "AE" },
  { label: "EPS", value: "EPS" },
  { label: "Union QE", value: "Union QE" },
  { label: "Alipay", value: "Alipay" },
  { label: "Wechat Pay", value: "Wechat Pay" },
  { label: "Visa", value: "Visa" },
  { label: "Master", value: "Master" },
  { label: "Union(CUP)", value: "Union(CUP)" },
  { label: "Received by bosses", value: "Received by bosses" },
];
